/*
 * @Author: wangyang
 * @Date: 2020-03-12 13:00:41
 * @LastEditors: wangyang
 * @LastEditTime: 2020-03-12 14:48:47
 * @Description:选择人员接口
 */
import request from '@/utils/request';
// 获取左侧菜单
export function getMenu() {
  return request({
    url: 'https://lutest.youlianfuwu.com/v1/modal-user/menus',
    method: 'get'
  });
}
// 获取人员列表
export function getList(params) {
  return request({
    url: '/v1/voucher/finduser',
    method: 'get',
    params: params
  });
}
// 提交人员
export function toSubmit(data) {
  return request({
    url: '/v1/package-user/add-cache',
    method: 'post',
    data: data
  });
}
// 已选人员列表 修改时
export function selectedPerson(params) {
  return request({
    url: '/v1/voucher/selects',
    method: 'get',
    params: params
  });
}